export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13539.edfe488b.jpg";